import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
var AiChartOptionsModal = /** @class */ (function (_super) {
    tslib_1.__extends(AiChartOptionsModal, _super);
    function AiChartOptionsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filters = {};
        _this.charts = [];
        return _this;
    }
    AiChartOptionsModal.prototype.beforeOpen = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.filters = e.params.filters;
                this.charts = e.params.charts;
                this.$root.$on("back", this.back);
                return [2 /*return*/];
            });
        });
    };
    AiChartOptionsModal.prototype.closed = function (e) {
        this.$root.$off("back", this.back);
    };
    AiChartOptionsModal.prototype.back = function (e) {
        e.stop();
        this.$modal.hide("chart-options");
    };
    AiChartOptionsModal = tslib_1.__decorate([
        Component
    ], AiChartOptionsModal);
    return AiChartOptionsModal;
}(Vue));
export default AiChartOptionsModal;
